import React from 'react';
import { placementStats, recruiters } from '../mock/data';
import { useReveal } from '../hooks/useReveal';
import { Building2 } from 'lucide-react';

function PStat({ s, i }) {
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${i * 100}ms` }}
      className={`reveal ${inView ? 'in-view' : ''} rounded-2xl bg-white/10 border border-white/15 backdrop-blur p-6 text-center`}
    >
      <div className="text-3xl md:text-4xl font-extrabold text-white">{s.value}</div>
      <div className="mt-2 text-blue-100/90 text-sm">{s.label}</div>
    </div>
  );
}

export default function Placements() {
  const { ref, inView } = useReveal();
  const doubled = [...recruiters, ...recruiters];

  return (
    <section id="placements" className="py-20 md:py-28 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0B2E6E 0%, #123FA0 100%)' }}>
      <div className="absolute -top-24 -right-20 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
      <div className="absolute -bottom-24 -left-20 w-96 h-96 rounded-full bg-white/5 blur-3xl" />
      <div className="container-x relative">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/10 text-blue-100 text-[12px] font-semibold tracking-[1.4px]">PLACEMENT &amp; CAREER</span>
          <h2 className="mt-4 text-white text-[34px] md:text-[44px] leading-tight font-extrabold">
            Building careers with top recruiters
          </h2>
          <p className="mt-4 text-blue-100/90">Our alumni work in leading pharmaceutical companies, hospitals, and research organizations.</p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {placementStats.map((s, i) => <PStat key={s.label} s={s} i={i} />)}
        </div>

        <div className="mt-14">
          <div className="text-center text-blue-100/90 uppercase tracking-[2px] text-[12px] font-semibold">Our Top Recruiters</div>
          <div className="mt-6 overflow-hidden mask-fade">
            <div className="marquee-track gap-3">
              {doubled.map((r, i) => (
                <div key={r + i} className="shrink-0 rounded-full bg-white text-[#0B2E6E] px-6 py-3 font-semibold flex items-center gap-2 shadow-lg">
                  <Building2 size={16} className="text-[var(--pca-blue)]" />
                  {r}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
